import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SETTORI, MEDIA } from "@/data/content";

export default function Settori() {
  return (
    <div data-testid="page-settori" className="pt-28">
      <section className="container-x py-16 sm:py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="overline">Settori</span>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight">
            Otto aree<br />di <span className="italic text-primary">specializzazione</span>.
          </h1>
          <p className="mt-8 lead max-w-2xl">
            Selezioniamo il settore che ti rappresenta per scoprire come progettiamo le coperture sulle reali esigenze della tua attività.
          </p>
        </div>
      </section>

      <section className="container-x pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {SETTORI.map((s, i) => (
            <Link
              key={s.slug}
              to={`/settori/${s.slug}`}
              data-testid={`settore-card-${s.slug}`}
              className="group block bg-background border border-foreground/10 hover:border-primary/40 transition-colors duration-500"
            >
              <div className="relative aspect-[5/4] overflow-hidden bg-muted">
                {s.image && (
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F2E]/60 via-transparent to-transparent" />
                <span className="absolute top-4 left-4 text-xs tracking-[0.28em] text-white/85 tabular-nums">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <ArrowUpRight className="absolute top-4 right-4 h-5 w-5 text-white/80 group-hover:text-[#89E877] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500" />
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="font-display text-2xl sm:text-3xl tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.short}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
